import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_set_rule_outbound_order_processing_schedule_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { schedule_name: string, properties: { is_active: boolean, max_parallel_requests: number, cron_expression: string } }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.schedule_name)) {
      $missingRequiredInParams.push('\'schedule_name\'');
    }
    if (isNil($inParams.properties)) {
      $missingRequiredInParams.push('\'properties\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

